<template>
  <div v-if="info && this.isShow" class="inner-content fs13" id="pages">
    <div class="page print-info-area p20">
      <div class="header heghtHeader">
        <div class="styleHeader">
          <div class="fLeft">{{ $t('doctor_in_charge_colon') }} {{ $t('doctor_doctor', {doctor: doctorInfo.name }) }}</div>
          <div class="fRight">{{ $t('output_date_and_time') }} {{ pdf.currentDateTime }} &emsp; 1/{{ pages + 2}}</div>
        </div>
        <div class="titleHeder">
          <h1>{{ $t('patient_information_and_seizure_status_graph') }}</h1>
        </div>
      </div>
      <div class="content">
        <div ref="infoBox">
          <div class="child-infor">
          <h3 class="fs18 titleHeading mb-3">{{ $t('patient_information') }}</h3>
            <table class="table-patient-info">
              <tr>
                <td style="min-width: 150px">{{ $t('name') }}</td>
                <td nowrap class="p-info-txt" style="min-width: 234px">{{ pdf.child_name }}</td>
                <td style="min-width: 250px">{{ $t('gender') }}</td>
                <td nowrap class="p-info-txt" style="min-width: 120px">{{ gender }}</td>
              </tr>
              <tr>
                <td style="min-width: 150px">{{ $t('age') }}</td>
                <td nowrap class="p-info-txt" style="min-width: 234px">{{ $tc('age_ages', age) }}</td>
                <td style="min-width: 250px">{{ $t('average_number_of_seizures_patient') }}</td>
                <td class="p-info-txt" style="min-width: 120px">{{ $tc('time_times', basic_info.average_seizure ) }}</td>
              </tr>
              <tr id="list-desease-name">
                <td>{{ $t('disease_name') }}</td>
                <td class="pl-3" colspan="3">
                  <ul>
                    <li v-for="(item, index) in diseaseName" :key="index">
                      {{' - ' + item.answer_value}}
                    </li>
                  </ul>
                </td>
              </tr>
            </table>
          </div>
          <div class="list-seizure-type">
            <div class="seizure-typr" v-for="(item, index) in basic_info.seizures_shortcat" :key="index">
              <div>
                <p v-html="$t('dot_tab_seizure_type_type', {type: shortcatLabel[index]})"></p>
                <p>&nbsp;&emsp;{{ 
                  basic_info.seizures_shortcat[index] && basic_info.seizures_shortcat[index].shortcat_name !== null ? basic_info.seizures_shortcat[index].shortcat_name : "－" 
                }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="patient-info-area pt10" >
            <p>{{ $t('dot_tab_medication_history') }}</p>
            <table class="mt10">
              <col style="width: 20%;" />
              <col style="width: 80%;" />
              <tr class="medicine">
                <th>{{ $t('prescription_start_date') }}</th>
                <th>{{ $t('prescription_drugs') }}</th>
              </tr>
              <tr class="medicine" v-for="item in medicines" :key="item.id">
                <td style="text-align: center">{{ item.date }}</td>
                <td>
                  <div>
                    <p v-for="(item, index) in item.name.split($t('comma'))" :key="index">{{ item }}</p>
                  </div>
                </td>
              </tr>
            </table>
          </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import Spinner from "@/js/components/Spinner"
import moment from "moment"

const limitHeightTwo = 970
const PAGE_HEIGHT = 1123
const PADDING = 20
const PAGE_TITLE_HEIGHT = 110
const TABLE_TITLE_HEIGHT = 40
const DEFAULT_ROW_HEIGHT = 40
const HEIGHT_OF_LIST_SEIZURE_TYPE = 250
const MIN_HEIGHT_OF_MEDICINES_TABLE = 100
export default {
  props: {
    isShow: {
      type: Boolean,
      default: true
    },

  },
  data() {
    return {
      shortcatLabel: ['A', 'B', 'C', 'D', 'E', 'F'],
      pages: 0
    }
  },
  components: {
    Spinner
  },
  computed: {
    ...mapState({
      info: state => state.patient.info,
      basic_info: state => state.patient.basic_info,
      base: state => state.homecare.base,
      doctorInfo: state => state.auth.doctorInfo,
      otpAccessToken: state => state.otp.otpAccessToken,
      pdf: state => state.patient.pdf,
      listMedicines: state => state.medicine.medicines
    }),
    medicines() {
      const medicineInfo = this.listMedicines.filter((item) => item.medicine_record.length > 0)
      return medicineInfo.map((item, index) => {
        const medicines = item.medicine_record.map((record) => record.medicine_name)
        return {
          date: moment(item.medicine_start_date).format('YYYY/MM/DD'),
          name: medicines.reduce((a,b) => a + this.$t('comma') + b)
        }
      })
    },
    gender() {
      return this.info.gender === 0 ? this.$t('male') : this.info.gender === 1 ? this.$t('female') : this.$t('not_identify')
    },
    age() {
      return moment().diff(moment(new Date(this.info.birthday)), "years")
    },
    diseaseName() {
      const listDiseaseName = []
      this.base.map(function(value) { 
        if (value.item_name === 'disease_name') { JSON.parse(value.answer).map(function(item) { listDiseaseName.push( item ) }) }
      })
      return listDiseaseName
    },
  },
  async mounted() {
    setTimeout(() => {
      this.checkTablePatientInfo()
      this.$emit('loaded', this.pages)
    }, 100);
  },
  methods: {
    checkTablePatientInfo() {
      const HEIGHT_OF_SPACE_AREA = PAGE_HEIGHT - PAGE_TITLE_HEIGHT - PADDING * 2
      let spaceArea = HEIGHT_OF_SPACE_AREA - TABLE_TITLE_HEIGHT
      let listElOnNewPage = []
      let indexNewPage = -1
      document.querySelector('.table-patient-info').querySelectorAll('tr').forEach(row => {
        if(row.id === 'list-desease-name') {
          spaceArea -= PADDING
          let listEl = document.querySelectorAll('.table-patient-info tr ul li')
          if(listEl.length == 0) {
            spaceArea -= DEFAULT_ROW_HEIGHT
          }
          else {
            listEl.forEach((el, index) => {
              spaceArea -= el.offsetHeight
              if(spaceArea < 0) {
                indexNewPage++
                listElOnNewPage.push([])
                listElOnNewPage[indexNewPage].push(el.innerHTML)
                spaceArea = HEIGHT_OF_SPACE_AREA - PADDING - el.offsetHeight
                el.classList.add('d-none')
              }
              else if(indexNewPage > -1) {
                listElOnNewPage[indexNewPage].push(el.innerHTML)
                el.classList.add('d-none')
              }
            })
          }
        }
        else {
          spaceArea-= row.offsetHeight
        }
      })
      listElOnNewPage.forEach((list, index) => {
        this.addNewPage('list-desease',list)
        if(index == listElOnNewPage.length -1) {
          spaceArea = HEIGHT_OF_SPACE_AREA - PADDING - (document.getElementsByClassName('table-patient-info')[index + 1]?.offsetHeight || 0)
        }
      })
      let isSeizureTypeBreakNewPage = false
      if(spaceArea < HEIGHT_OF_LIST_SEIZURE_TYPE) {
        isSeizureTypeBreakNewPage = true
        let listSeizureTypeEl = document.getElementsByClassName('list-seizure-type')[0]
        this.addNewPage('list-seizure-and-medicine', listSeizureTypeEl)
        listSeizureTypeEl.style.display = 'none'
        spaceArea = HEIGHT_OF_SPACE_AREA - PADDING
      }
      else if( listElOnNewPage.length > 0 ) {
        let pagesEl = document.getElementById("pages")
        let listSeizureTypeEl = document.getElementsByClassName('list-seizure-type')[0]
        pagesEl.childNodes[pagesEl.childNodes.length - 1].appendChild(listSeizureTypeEl)
      }
      spaceArea -= HEIGHT_OF_LIST_SEIZURE_TYPE
      if(spaceArea < MIN_HEIGHT_OF_MEDICINES_TABLE) {
        let tableMedicineEl = document.getElementsByClassName('patient-info-area')[0]
        this.addNewPage('list-seizure-and-medicine', tableMedicineEl)
        tableMedicineEl.style.display = 'none'
        spaceArea = HEIGHT_OF_SPACE_AREA - PADDING
      }
      else if( listElOnNewPage.length > 0 || isSeizureTypeBreakNewPage) {
        let pagesEl = document.getElementById("pages")
        let tableMedicineEl = document.getElementsByClassName('patient-info-area')[0]
        pagesEl.childNodes[pagesEl.childNodes.length - 1].appendChild(tableMedicineEl)
      }
      this.displayInfo(spaceArea)
    },
    addNewPage(type, listEl) {
      let headerEl = document.getElementsByClassName('header')[0].outerHTML
      let newPage = document.createElement('div')
      newPage.classList.add('page', 'print-info-area', 'fs13', 'p20', 'mb-4')
      newPage.style.backgroundColor = 'white'
      newPage.style.height = '1123px'
      newPage.style.marginTop = '20px'
      newPage.innerHTML = ''
      var newEl = ''
      newEl += headerEl
      newEl += ` <div class="bodyPDF">`
      switch (type) {
        case "list-desease":
          newEl += `<div class="detail-content-area">
                <table class='table-patient-info'>
                  <tr>
                    <td>${this.$t('disease_name')}</td>
                    <td class="pl-4" colspan="3">
                      <ul>`
          listEl.forEach(el => newEl += `<li>${el}</li>`)
          newEl += `  </ul>
                    </td>
                  </tr>
                </table>
              </div>`
          break;
        case "list-seizure-and-medicine":
          newEl += listEl.outerHTML
          break;
        default:
          break;
      }
      newEl +=`</div>`
      newPage.insertAdjacentHTML('beforeend', newEl)
      document.getElementById('pages').appendChild(newPage)
    },
    nextUntil(elem, selector) {
      var siblings = [];
      siblings.push(elem)
      elem = elem.nextElementSibling;
      while (elem) {
        if (elem.matches(selector)) break
        siblings.push(elem)
        elem = elem.nextElementSibling
      }
      return siblings
    },
    displayInfo(space) {
      const limitHeight = space
      let startHeight = document.getElementsByClassName('medicine')[0]?.offsetHeight || 0
      const medicines = document.getElementsByClassName('medicine')
      for (let i = 0; i < medicines.length; i += 1) {
        startHeight = startHeight + medicines[i].offsetHeight
        if (this.pages === 0) {
          if(startHeight > limitHeight) {
            this.pages += 1
            medicines[i].classList.add('new')
            startHeight = medicines[i]?.offsetHeight || 0
          }
        } else {
          if(startHeight > limitHeightTwo) {
            this.pages += 1
            medicines[i].classList.add('new')
            startHeight = medicines[i]?.offsetHeight || 0
          }
        }
      }
      const newEls = document.getElementsByClassName('new')
      for (var i = 0; i < newEls.length; i+=1) {
        let newPage = document.createElement('div')
        newPage.classList.add('page')
        newPage.style.backgroundColor = 'white'
        newPage.style.height = '1123px'
        newPage.style.marginTop = '20px'
        newPage.innerHTML = ''
        var newEl = ''
        newEl += `<div class="p20">
          <div class="header heghtHeader">
            <div class="styleHeader">
              <div class="fLeft">${this.$t('doctor_in_charge_colon')} ${this.$t('doctor_doctor', {doctor: this.doctorInfo.name})}</div>
              <div class="fRight">${this.$t('output_date_and_time')} ${ this.pdf.currentDateTime } &emsp; ${i + 2 }/${ newEls.length + 2 }</div>
            </div>
            <div class="titleHeder">
              <h1>${this.$t('patient_information_and_seizure_status_graph')}</h1>
            </div>
          </div>
          <div class="content">
            <div class="patient-info-area pt10">
              <table>
                  <col style="width: 20%;" />
                  <col style="width: 80%;" />
                `
          const newTable = this.nextUntil(newEls[i], '.new')
          for (let j = 0; j < newTable.length; j += 1) {
            newEl += newTable[j].innerHTML
            newEl += '</tr><tr>'
            newTable[j].style.display = 'none'
          }
          newEl += `</table>
                </div>
              </div>
            </div>`
        newPage.insertAdjacentHTML('beforeend', newEl)
        document.getElementById('pages').appendChild(newPage)
      }
    }
  }
}
</script>

<style lang="css">
    .fs13 {
      font-size: 13px;
    }
    .fs18 {
      font-size: 18px;
    }
    .print-info-area {
      background-color: white;
      height: 1123px;
    }
    .styleHeader {
      overflow: hidden;
      border-bottom: 4px solid #f98ea1;
      margin-bottom: 18px;
    }
    .titleHeder h1 {
      font-size: 23px;
      font-weight: 300;
      text-align: center;
      border-bottom: 4px solid #f98ea1;
      padding-bottom: 18px;
    }
    .child-infor h3 {
      border-bottom: 1px solid #f98ea1;
    }
    .p-info-txt {
      padding-left: 15px;
      padding-right: 20px;
    }
    .title {
      text-align: center;
      font-size: 25px;
      font-weight: 600;
      margin: 10px;
    }
    .pt10 {
      padding-top: 10px;
    }
    .mt10 {
      margin-top: 10px;
    }
    .heghtContent {
      height: 1043px;
    }
    .heghtHeader {
      height: 80px;
    }
    .height-child-info {
      height: 400px;
    }
    .fLeft {
      float: left;
    }
    .fRight {
      float: right;
    }
    .patient-info-area {
      width: 100%;
    }
    .patient-info-area table {
      border: 1px solid #999999;
      width: 100%;
    }
    .patient-info-area table tr {
      border: 1px solid #999999;
    }
    .patient-info-area table tr th {
      border: 1px solid #999999;
      background: #ffe6e6!important;
      padding: 3px;
      text-align: center;
      font-weight: normal;
      font-size: 14px;
      height: 30px;
    }
    .patient-info-area table tr td {
      border: 1px solid #999999;
      background: #ffffff;
      padding: 3px;
      text-align: left;
      vertical-align: middle;
      font-size: 14px;
      height: 30px;
    }
    .patient-info-area table tr:nth-child(odd) td {
      border: 1px solid #999999;
      background: #fdf2f2!important;
      padding: 3px;
      text-align: left;
      font-size: 0.8rem;
      vertical-align: middle;
    }
    .heghtHeader {
      height: 110px !important;
    }
    .table-patient-info {
      width: 100%;
    }
    .table-patient-info tr td:nth-child(odd) {
      background-color: #FDF2F2;
      vertical-align: middle;
      max-width: 155px;
      min-width: 155px;
      width: 155px;
    }
    .table-patient-info tr td {
      border: 0.5px solid #FF8EA1;
      padding: 10px 5px;
    }
    .table-patient-info tr td ul li {
      list-style: none;
      line-height: 20px;
      font-size: 14px;
    }
    .list-seizure-type {
      margin-top: 10px;
    }
    .seizure-typr p {
      line-height: 20px;
    }
  </style>